module.exports = __webpack_public_path__ + "img/saham.268bb871.jpg";